import GetEternal from './getEternal';
import './App.css';

function App() {
  return (
    <div class="container-fluid my-4"><GetEternal/></div>
  );
}

export default App;
